<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model.ts'
import { VModal } from '@/shared/ui'
import { onMounted, ref, watch } from 'vue'
import { ObjectSearch } from '@/widgets'
import { useSendForm } from './../model/api.ts'
import { useAuth } from '@/entities/Auth'
import { ObjectTypeIds } from '@/entities/Object'

const model = useModel()
const auth = useAuth()
const { sendForm, isPending } = useSendForm()

const valid = ref(false)

/**
 * Функция обработчик отправки формы
 */
const submitHandler = () => {
  sendForm(model.data, valid.value).then(model.closeForm)
}

/**
 * Устанавливаем группу по умолчанию
 */
onMounted(() => {
  model.setGroup(auth.user?.object_group.id || 1)
})

/* Подгружаем данные формы */
const { refetch, isPending: isLoading } = model.loadData()

watch(
  () => model.editId,
  () => refetch(),
)
</script>

<template>
  <VModal v-model="model.openForm" :max-width="450" :title="$t('itf.schedules_copy')">
    <VForm class="pt-2" v-model="valid" @submit.prevent="submitHandler" :disabled="isLoading">
      <ObjectSearch
        v-model="model.data.group_object_list_id"
        :label="$t('itf.select_root_object')"
        :object_type="ObjectTypeIds.GROUPS"
      />

      <VTextField v-model="model.data.name" :label="$t('itf.name_label')" disabled />

      <div class="form__btn_right mt-4">
        <VBtn type="submit" :loading="isPending">{{ $t('itf.copy') }}</VBtn>

        <VBtn color="default" @click="model.openForm = false">
          {{ $t('itf.close') }}
        </VBtn>
      </div>
    </VForm>
  </VModal>
</template>
